export class JureCommission {
    static jsonMap = {
        idJure: 'idJure',
        idCommission: 'idCommission',
        nom: 'nom'
    };

    idJure: number;
    idCommission: number;
    nom: string;
}
